import { TimeFrame } from "charts/src/types/chart";

export const isChartSupportGivenTimeFrame = (
  timeFrameOption: TimeFrame[],
  timeFrame: TimeFrame
) => {
  return timeFrameOption.includes(timeFrame);
};
